export default {
  data() {
    return {
      disabled: false,
      text: "获取验证码"
    };
  },
  methods: {
    sendCode() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 60;
      this.text = n + "s";
      const run = setInterval(() => {
        n = n - 1;
        if (n < 0) {
          clearInterval(run);
          this.disabled = false;
          this.text = "重新获取";
        } else {
          this.text = n + "s";
        }
      }, 1000);
    }
  }
};
